import { useRef, useEffect, useState } from 'react';
import Icon from '@/components/core/icon.js';

function ModalWrapper({
  // eslint-disable-next-line react/prop-types
  children, onClose, afterRender, delay,
}) {
  const contentRef = useRef();
  const [show, setShow] = useState(!delay);

  useEffect(() => {
    if (afterRender) {
      afterRender();
    }
  }, [afterRender]);

  useEffect(() => {
    let timer;
    if (delay) {
      if (!show) {
        timer = setTimeout(() => setShow(true), delay);
      }
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [show]);

  return (
    <div className="z-20 bg-white">
      <div className="z-10 transition duration-300 cursor-pointer group rounded-full flex items-center justify-center fixed p-3 h-12 w-12 md:p-2 md:h-10 md:w-10 bottom-10 right-1/2 translate-x-1/2 md:translate-x-0 md:top-4 md:right-4 hover:md:bg-purple-0 bg-black md:bg-white" onClick={() => onClose()}>
        <Icon name="close" className="transition duration-300 w-4 fill-current text-white md:text-purple-5/50 group-hover:text-black" />
      </div>
      <div ref={contentRef}>
        {children}
      </div>
    </div>
  );
}
export default ModalWrapper;
